import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import BannerAd from '../../../shared/components/BannerAd/BannerAd';
import BasicCalloutWrapper from '../../../shared/components/BasicCalloutWrapper/BasicCalloutWrapper';
import { MonthlyPerformanceReports as monthlyPerformanceReportsAds } from './ads';
import { addMetaCanonical } from '../../../shared/lib/meta-tags';
import BodyHeader from '../../../shared/components/BodyHeader/BodyHeader';

const baseTitle = 'On-time Performance Reports';
const desktopLanguage = 'This visualization is too large for mobile browsers. Please view this page on a desktop browser.';

const isAirlineReport = ({ pathname }) => pathname.indexOf('airports') === -1;
const title = location => `${isAirlineReport(location) ? 'Airline' : 'Airport'} ${baseTitle}`;

const metaTags = (location) => {
  const pageTitle = title(location);
  const isAirlinePage = isAirlineReport(location);
  const description = `The FlightStats ${pageTitle} compares the on-time ${isAirlinePage ? 'arrival performance of major, regional and low-cost airlines' : 'departure performance of airports'} around the world.`;
  const metaWithoutCanonical = {
    title: pageTitle,
    meta: [
      { name: 'description', content: description },
      { name: 'keywords', content: pageTitle },
      { property: 'og:title', content: pageTitle },
      { property: 'og:description', content: description },
    ],
  };
  return addMetaCanonical(metaWithoutCanonical, location.pathname);
};

const determineTopCallout = (isAirlinePage) => {
  const titleText = isAirlinePage ?
    'FlightStats OTP Analysis Workbook' :
    'FlightStats Monthly Newsletter';
  const subText = isAirlinePage ?
    'Gain a better understanding on how your OTP ranks compared to your competitors allowing you to create more effective loyalty and marketing programs for your customers.' :
    'Sign up for our monthly newsletter and stay up-to-date on the latest news.';
  const buttonLabel = isAirlinePage ?
    'REQUEST A DEMO TODAY' :
    'SIGN UP & GET UPDATES';
  const onClickURL = isAirlinePage ?
    'https://www.flightstats.com/company/contact/request-a-demo-of-the-flightstats-on-time-performance-otp-analysis-workbook/' :
    'http://eepurl.com/bWn1ff';
  const onClickGALabel = isAirlinePage ?
    'AirlineOTPRequestDemoCallout' :
    'AirportOTPNewsletterCallout';

  return (
    <div style={{ marginTop: '20px' }}>
      <BasicCalloutWrapper
        openNewTab
        titleText={titleText}
        subText={subText}
        buttonLabel={buttonLabel}
        onClickURL={onClickURL}
        onClickGALabel={onClickGALabel}
      />
    </div>
  );
};

const determineBottomCallout = (isAirlinePage) => {
  const subText = isAirlinePage ?
    'See how airports are performing with FlightStats monthly Airport On-time Performance Report. This report compares the on-time arrival performance of major and regional airports around the world.' :
    'See how airlines are performing with FlightStats monthly Airline On-time Performance Report. This report compares the on-time arrival performance of major, regional and low-cost airlines around the world.';
  const buttonLabel = isAirlinePage ?
    'Airport Performance Reports' :
    'Airline Performance Reports';
  const onClickURL = isAirlinePage ?
    '/monthly-performance-reports/airports' :
    '/monthly-performance-reports/airlines';
  const onClickGALabel = isAirlinePage ?
    'AirlineOTPViewAirportsCallout' :
    'AirportOTPViewAirlineCallout';

  return (
    <div style={{ marginTop: '20px', marginBottom: '20px' }}>
      <BasicCalloutWrapper
        subText={subText}
        buttonLabel={buttonLabel}
        onClickURL={onClickURL}
        onClickGALabel={onClickGALabel}
      />
    </div>
  );
};

const MonthlyPerformanceReports = (props) => {
  const {
    user,
    location,
  } = props;

  const meta = metaTags(location);
  const { subscriptionActive } = user || {};

  const isAirlinePage = isAirlineReport(location);
  const ads = isAirlinePage ?
    monthlyPerformanceReportsAds.airlines : monthlyPerformanceReportsAds.airports;
  const tableauURL = isAirlinePage ?
    'https://public.tableau.com/views/AirlineOn-timePerformance/GlobalAirlines' :
    'https://public.tableau.com/views/AirportOn-timePerformance/GlobalHubs';

  const topAd = (
    <BannerAd
      topAd
      mobileAd={ads.topMobile}
      desktopAd={ads.top}
      subscriptionActive={subscriptionActive}
    />
  );

  return (
    <div className='monthly-performance-reports-container'>
      <Helmet {...meta} />
      {topAd}
      <div className='tableauReport'>
        <BodyHeader
          primary={title(location)}
          primaryAlt={title(location)}
        />
        {determineTopCallout(isAirlinePage)}
        <div className='pleaseUseDesktop'>
          <p>{desktopLanguage}</p>
        </div>
        <div className='tableauTable'>
          <iframe
            title={title(location)}
            src={`${tableauURL}?:showTabs=y&:tabs=y&:toolbar=y&:animate_transition=y&:animate_transition=y&:display_static_image=y`}
            width='1200'
            height='950'
          />
          <p className='airlineDisclaimer' style={!isAirlinePage ? { display: 'none' } : null}>*For European Major Airlines Norwegian Air Shuttle (DY) does not include Norwegian Air International (D8) in OTP performance calculations</p>
        </div>
        {determineBottomCallout(isAirlinePage)}
      </div>
    </div>
  );
};

MonthlyPerformanceReports.propTypes = {
  location: PropTypes.object,
  user: PropTypes.object,
};

export default MonthlyPerformanceReports;



// WEBPACK FOOTER //
// ./modules/MonthlyPerformanceReports/components/container.js